import { merge } from 'lodash';
import { gehaThemeOverride } from './gehaThemeOverride';
import { uhcThemeOverride } from './uhcThemeOverride';
import { optumThemeOverride } from './optumThemeOverride';
import { gehaThemeOverrideV2 } from './gehaThemeOverrideV2';

export function getTheme(
  portalTheme: string,
  portalIdentifier: string | undefined,
  themeOverride: object | undefined | null,
  isGEHAV2: boolean = false
) : object {
  if (!themeOverride) {
    if (portalTheme === 'optum') {
      return optumThemeOverride;
    } else {
      return uhcThemeOverride;
    }
  } else {
    if (portalIdentifier === 'geha') {
      return merge({}, themeOverride, (isGEHAV2? gehaThemeOverrideV2 :gehaThemeOverride));
    } else {
      return merge({}, themeOverride, uhcThemeOverride);
    }
  }
}